import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/Service/Common.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { FormGroup, FormControl } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { LoaderService } from 'src/app/Service/Loader/loader.service';

@Component({
  selector: 'app-productivity-report',
  templateUrl: './productivity-report.component.html',
  styleUrls: ['./productivity-report.component.css']
})
export class ProductivityReportComponent implements OnInit {
  projectId!: number;
  groupId!: number;
  memberId: number = 0;
  public reportServer!: string;
  public reportUrl!: string;
  public showParameters!: string;
  public parameters: any;
  public language!: string;
  public height!: number;
  public width!: number;
  public toolbar!: string;
  projectList: ProjectViewModel[] = [];
  searchMemberList: any[] = [];
  public selectedProject: number = -2;
  public selectedMember: number = -2;

  public searchForm: FormGroup = new FormGroup({
    ctrlProject: new FormControl(),
    ctrlMember: new FormControl()
  });

  constructor(
    private commonService: CommonService,
    private projectInfoService: ProjectInfoService,
    private notificationService: NotificationService,
    public projectMemberLinkService: ProjectMemberLinkService,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.loaderService.isLoading.next(true);
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.getProjectList();
    this.getMemberList();
    this.loaderService.isLoading.next(false);
  }

  async getProjectList() {
    await this.projectInfoService.getProjectList(this.memberId).subscribe((data: ProjectViewModel[]) => {
      this.projectList = data;
      for (let i = 0; i < this.projectList.length; i++) {
        this.projectList[i]['projCodeDesc'] = this.projectList[i].projectCode + ' - ' + this.projectList[i].projectDescription;
      }
    });
  }

  async getMemberList() {
    this.searchMemberList = await this.projectMemberLinkService.getSelectedMemberList(this.projectId, this.groupId).toPromise();
  }

  public EmbedSSRSReport() {
    this.language = "en-us";
    this.width = 1000;
    this.height = 620;
    this.toolbar = "true";
    this.showParameters = "false";
  }

  public setSelectedProject(event: any) {
    this.loaderService.isLoading.next(true);
    this.selectedProject = event.value;

    this.reportUrl = '';
    this.parameters = null;
    this.EmbedSSRSReport();
    this.loaderService.isLoading.next(false);
  }

  public setSelectedMember(event: any) {
    this.loaderService.isLoading.next(true);
    this.selectedMember = event.value;

    this.reportUrl = '';
    this.parameters = null;
    this.EmbedSSRSReport();
    this.loaderService.isLoading.next(false);
  }

  public getReport() {
    this.loaderService.isLoading.next(true);
    this.reportUrl = '';

    if (this.selectedProject != -2 && this.selectedMember == -2) {
      this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/ProjectProductivitySummary";
      this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/ProjectProductivitySummary";
      this.parameters = {
        "Project_Id": this.selectedProject
      };
    }
    else if (this.selectedProject == -2 && this.selectedMember != -2) {
      this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/MemberProductivitySummary";
      this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/MemberProductivitySummary";

      this.parameters = {
        "Member_Id": this.selectedMember
      };
    }
    else if (this.selectedProject != -2 && this.selectedMember != -2) {
      this.reportServer = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/ProjectProductivitySummary";
      this.reportUrl = environment.reportHost + "EIP40Reports/EIP4EDMS/EDMS/ProjectProductivitySummary";
      this.parameters = {
        "Project_Id": this.selectedProject,
        "Member_Id": this.selectedMember
      };
    }

    this.EmbedSSRSReport();
    this.loaderService.isLoading.next(false);
  }
}
